import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function Guarantee() {
  return <section className="bg-cream px-4 py-14 sm:px-5 sm:py-24" data-id="element-85" data-mp="1o2vg4lt3wh4z">
      <Reveal data-id="element-86" data-mp="22368jta2e3s9">
        <div className="mx-auto max-w-3xl rounded-[1.5rem] border-2 border-dashed border-ink/25 bg-sand px-5 py-9 text-center sm:rounded-[2rem] sm:px-12 sm:py-11" data-id="element-87" data-mp="223ofpky9m2ey">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-ink shadow-card sm:h-14 sm:w-14" aria-hidden="true" data-id="element-88" data-mp="19eqvvdeenxk3">
            <ShieldCheckIcon className="h-6 w-6 text-sun sm:h-7 sm:w-7" strokeWidth={2.5} data-id="element-89" data-mp="14gpgp3k3oidw" />
          </span>
          <h2 className="display mt-5 text-[1.55rem] text-ink sm:mt-6 sm:text-[2.6rem]" data-id="element-90" data-mp="1j5c3fqc24cf5">
            Zero rischi · garanzia di 7 giorni
          </h2>
          <p className="mx-auto mt-3.5 max-w-xl text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-4 sm:text-lg" data-id="element-91" data-mp="qo9eu62xqqek">
            Apri i volumi, guarda i bonus ed esplora i progetti con tuo figlio.
            Se entro i primi 7 giorni senti che il Laboratorio del Giovane
            Inventore non è quello che ti aspettavi, puoi richiedere il rimborso
            completo. Nessuna domanda scomoda.
          </p>
        </div>
      </Reveal>
    </section>;
}